import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  background: [
    'radial-gradient(circle at 12% 18%, rgba(31, 126, 95, 0.12), transparent 28%)',
    'radial-gradient(circle at 88% 82%, rgba(0, 47, 115, 0.12), transparent 30%)',
    'linear-gradient(135deg, #F7FBF9 0%, #F4F7FC 48%, #F8FAFD 100%)',
  ].join(', '),
  display: 'flex',
  boxSizing: 'border-box',
  justifyContent: 'center',
  maxWidth: '100vw',
  minHeight: '100dvh',
  overflowX: 'hidden',
  padding: 'clamp(16px, 4vw, 48px)',
  position: 'relative',
  width: '100%',
  '&::before, &::after': {
    border: '1px solid rgba(0, 47, 115, 0.08)',
    borderRadius: '50%',
    content: '""',
    pointerEvents: 'none',
    position: 'absolute',
  },
  '&::before': {
    height: 220,
    left: '-90px',
    top: '12%',
    width: 220,
  },
  '&::after': {
    bottom: '8%',
    height: 300,
    right: '-130px',
    width: 300,
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(1.5),
    '&::before, &::after': {
      display: 'none',
    },
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.96)',
  border: '1px solid rgba(190, 207, 227, 0.85)',
  borderRadius: 28,
  boxSizing: 'border-box',
  boxShadow: '0 26px 70px rgba(25, 57, 93, 0.13)',
  maxWidth: 'min(940px, 100%)',
  minWidth: 0,
  padding: 'clamp(32px, 5vw, 58px)',
  position: 'relative',
  width: '100%',
  zIndex: 1,
  '& > .MuiBox-root:first-of-type': {
    paddingBottom: theme.spacing(3.5),
  },
  '& img': {
    height: 'auto',
    maxWidth: 220,
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    borderRadius: 20,
    minHeight: 'calc(100dvh - 24px)',
    padding: theme.spacing(3, 2),
    '& > .MuiBox-root:first-of-type': {
      paddingBottom: theme.spacing(2.5),
    },
    '& img': {
      maxWidth: 184,
    },
  },
}));

export const FooterText = styled(Typography)(({ theme }) => ({
  color: '#77869A',
  fontSize: 12.5,
  fontWeight: 400,
  lineHeight: 1.6,
  marginTop: 'clamp(32px, 5vw, 52px)',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(4),
  },
}));
